module.exports = __webpack_public_path__ + "static/img/jsmagic1pict1.f8da4bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jsmagic1pict1.jpg
// module id = qWRd
// module chunks = 0